export const READ = 'READ'
export const UNREAD = 'UNREAD'
